import { render, staticRenderFns } from "./AccontQuota.vue?vue&type=template&id=3d7c7ae1&"
import script from "./AccontQuota.vue?vue&type=script&lang=js&"
export * from "./AccontQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports